<template>
  <div class="container no-padding">
    <div class="mb-8 flex flex-row gap-4">
      <div
          class="w-44 p-6 pt-12 pb-2 bg-white rounded shadow border-2 relative flex flex-col items-center justify-between cursor-pointer hover:border-onvocado-primary">
        <img class="w-12 mb-4" src="/onvocado_logo.png" alt="Onvocado Logo">
        <span class="text-xs text-center leading-tight text">Data securely stored in Onvocado</span>
        <span></span>
        <span class="absolute top-2 left-2 px-2 text-sm leading-sm bg-onvocado-primary rounded-full">active</span>
      </div>
      <div v-for="integration in filteredIntegrations" :key="integration.id"
           class="w-44 p-6 pt-12 pb-2 bg-white rounded shadow border-2 relative flex flex-col items-center justify-between cursor-pointer hover:border-onvocado-primary"
           :class="$style.card"
           @click.stop="$emit('open-integration', integration.id, integration.target)">
        <!-- Conditionally render based on the target -->
        <img v-if="integration.target === 'WEBHOOK'" class="mb-2" src="/integrations/webhook.svg" alt="Webhook Logo">
        <img v-else-if="integration.target === 'ZAPIER'" class="mb-2" src="/integrations/zapier-logo.svg"
             alt="Zapier Logo">
        <span class="text-sm text-center">{{ integration.name }}</span>
        <span v-if="integration.active"  class="absolute top-2 left-2 px-2 text-sm leading-sm bg-onvocado-primary rounded-full">active</span>

        <i class="el-icon-delete text-xl absolute top-2 right-2 invisible transition-all hover:text-onvocado-red hover:scale-110"
           aria-label="Delete"
           title="Delete"
           @click.stop="removeIntegration(integration.id)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { errorMessages } from '@meta/errorMessages'

export default {
  name: 'ListView',
  data() {
    return {
      errorMessages,
      enableUpdate: false,
    }
  },
  computed: {
    ...mapState('integration', ['integrations']),
    targetWidgetID() {
      return this.$store.state.campaign.widget.targetWidgetID
    },
    filteredIntegrations() {
      return this.integrations.filter(integration => integration.widget === this.targetWidgetID)
    }
  },
  methods: {
    ...mapActions('integration', ['deleteIntegration']),
    removeIntegration(integrationId) {
      this.$msgbox.confirm('Are you sure you want to delete this integration?')
          .then(() => {
            this.deleteIntegration(integrationId)
                .then(() => {
                  this.$message({
                    type: 'success',
                    message: 'Integration deleted successfully',
                  })
                })
                .catch((error) => {
                  this.$message({
                    type: 'error',
                    message: this.errorMessages.default,
                  })
                  console.error(error)
                })
          })
          .catch(() => {
            // User canceled the deletion
          })
    },
  },
}
</script>

<style lang="scss" module>
.card {
  &:hover {
    i {
      @apply visible;
    }
  }
}
</style>